import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 3
  d.useSystemTimer += ds
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      let sys = voyageTilemap.getSystemSafe(tHere.text3.replace('loader-', ''))
      if (sys) {
        if (sys.system) {
          if (sys.system.ammo > 0) {
            voyageCrew.say(obj, 'Already loaded')
          } else {
            sys.system.ammo = 1
            voyageCrew.say(obj, 'Loading')
            voyageSounds.playLoadTorpedo()
          }
        }
      }
    }
  }
}
